import React, { useState } from "react";
import {
  styled,
  TableCell,
  tableCellClasses,
  TableRow,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import ToggleIcon from "../../../Components/ToggleIcon";
import { useSocketClient } from "../../../contexts/SocketClientProvider";
import useDeleteData from "../../../hooks/useDeleteData";
import { IControl } from "../types";
import { ITimer } from "./types";
import { timerToString, timerTriggerToString } from "./utils";
import { useTranslation } from "react-i18next";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontWeight: "bold",
    padding: "2px 8px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "2px 8px",
  },
}));

const TimerListItem = (props: { control: IControl; timer: ITimer }) => {
  const { control, timer } = props;
  const [isEnabled, setIsEnabled] = useState<boolean>(timer.is_enabled);
  const socketClient = useSocketClient();
  const { palette } = useTheme();
  const { t } = useTranslation();

  const toggleIsEnabled = () => {
    const newIsEnabled = !isEnabled;
    socketClient.update_attribute({
      type: "timer",
      id: timer.id,
      attribute: "is_enabled",
      value: newIsEnabled,
    });
    setIsEnabled(newIsEnabled);
  };

  const timerString = timerToString(timer);
  const deleteHandler = useDeleteData(
    t("Timer WHAT", { what: timerString }),
    `/controls/${control.id}/timers/${timer.id}`
  );

  return (
    <TableRow sx={{ padding: 0 }}>
      <StyledTableCell align="left">
        <b>{t(timer.action.parameter as string)}</b>
        <div>{timerTriggerToString(timer)}</div>
      </StyledTableCell>
      <StyledTableCell align="right">
        <ToggleIcon
          name={isEnabled ? "timer-play-outline" : "timer-pause-outline"}
          onClick={() => toggleIsEnabled()}
          color={palette.primary.main}
        />
      </StyledTableCell>
      <StyledTableCell align="right">
        <Link to={`/controls/${timer.action.control_id}/timers/${timer.id}`}>
          <ToggleIcon
            name={"timer-edit-outline"}
            color={palette.primary.main}
          />
        </Link>
      </StyledTableCell>
      <StyledTableCell align="right">
        <ToggleIcon
          name={"timer-remove-outline"}
          onClick={deleteHandler}
          color={palette.primary.main}
        />
      </StyledTableCell>
    </TableRow>
  );
};

export default TimerListItem;
